export default __webpack_public_path__ + "static/media/spinner.98f1a0f1.gif";